export const EducationData = [
  {
    company: "Epicodus",
    title: "Web Development",
    description: "Epicodus offers full-time courses in languages such as C#, JavaScript, Ruby, and more. Every track starts with Introduction to Programming and includes an advanced JavaScript course, as well as two language-specific courses — four five-week sessions in total. In addition, students complete two weeks of job and internship prep and finish their studies with a five-week internship.",
    items: [
      {
        name: "Skills Learned:",
        points: [
          "Intro to Programming: HTML, CSS, JavaScript and GitHub.",
          "C#, .Net Core, Basic MVC web apps, Karma & Jasmin testing, MySQL database",
          "Advanced JavaScript Libraries and Frameworks: jQuery, Angular and React."
        ],
      }
    ],
    image: 'epicodus.png',
    technologies: ['JavaScript', 'React', 'Angular', 'C#', 'HTML', 'CSS'],
  },

  {
    company: "Central Washington University",
    title: "Web Development",
    description: "",
    items: [
      {
        name: "Major: Business Administration",
        points: [
          "Supply Chain Management Specialization",
          "Logistics and Inventory Management.",
        ],
      },
      {
        name: "Minor: Mathematics",
        points: [
          "Calculus I, II, III, and IV",
          "Linear Algebra and Finite Math"
        ],
      },
      {
        name: "Minor: Family Studies",
        points: [
          "Working with small groups and creating an environment that breeds communication and teamwork",
        ],
      },
    ],
    image: 'cwu.jpg',
    technologies: ['JavaScript', 'React', 'Angular', 'C#', 'HTML', 'CSS'],
  },


];